import api from '../../store/config/api';
import { TRIGGER as SCHEMA } from '../../schemas';
import { deleteWebhook } from './webhook';
import { deleteUpcoming } from './upcoming';

export const [
  GET_TRIGGER,
  GET_TRIGGER_REQUEST,
  GET_TRIGGER_SUCCESS,
  GET_TRIGGER_FAILURE
] = api.buildTypes('GET_TRIGGER');

export function getTrigger({ teamName, triggerID }) {
  return {
    type: GET_TRIGGER,
    payload: {
      url: `/teams/${teamName}/triggers/${triggerID}`,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  UPDATE_TRIGGER,
  UPDATE_TRIGGER_REQUEST,
  UPDATE_TRIGGER_SUCCESS,
  UPDATE_TRIGGER_FAILURE
] = api.buildTypes('UPDATE_TRIGGER');

export function updateTrigger({ teamName, trigger }) {
  return {
    type: UPDATE_TRIGGER,
    payload: {
      url: `/teams/${teamName}/triggers/${trigger.triggerID}`,
      schema: SCHEMA,
      options: {
        method: 'PUT',
        body: trigger
      }
    }
  };
}

export const [
  DELETE_TRIGGER,
  DELETE_TRIGGER_REQUEST,
  DELETE_TRIGGER_SUCCESS,
  DELETE_TRIGGER_FAILURE
] = api.buildTypes('DELETE_TRIGGER');

export function deleteTrigger({ teamName, triggerID = '' }) {
  if (triggerID.match(/^w_/)) {
    return deleteWebhook({ teamName, webhookID: triggerID.replace(/^w_/, '') });
  } else if (triggerID.match(/^s_/)) {
    return deleteUpcoming({
      teamName,
      upcomingID: triggerID.replace(/^s_/, '')
    });
  } else {
    return {
      type: DELETE_TRIGGER,
      payload: {
        url: `/teams/${teamName}/triggers/${triggerID}`,
        schema: SCHEMA,
        options: {
          method: 'DELETE'
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./js/actions/api/trigger.js